import * as actionTypes from './actionTypes';

import { createActionObject, getNoArgDispatcherFunc } from '../../helpers/common';

import * as strings from '../../helpers/strings';

export const setId = id => dispatch => dispatch(
  createActionObject(
    actionTypes.SET_ID,
    { 
      id,
      idError: id ? "" : strings.msgIdRequired
    }
  )
);

export const setName = name => dispatch => dispatch(
  createActionObject(
    actionTypes.SET_NAME,
    { 
       name
    }
  )
);

export const setProjectName = projectName => dispatch => dispatch(
  createActionObject(
    actionTypes.SET_PROJECT_NAME,
    { 
      projectName
    }
  )
);

export const setRefSlowDataFile = refslowdatajson => dispatch => dispatch(
  createActionObject(
    actionTypes.SET_REF_SLOW_DATA,
    { 
      refslowdatajson
    }
  )
);

export const setRefCapacityDataFile = refcapacitydatajson => dispatch => dispatch(
  createActionObject(
    actionTypes.SET_REF_CAPACITY_DATA,
    { 
      refcapacitydatajson
    }
  )
);

export const setRefFastDataFile = reffastdatajson => dispatch => dispatch(
  createActionObject(
    actionTypes.SET_REF_FAST_DATA,
    { 
      reffastdatajson
    }
  )
);

export const setDescription = description => dispatch => dispatch(
  createActionObject(
    actionTypes.SET_DESCRIPTION,
    { 
      description
    }
  )
)

export const setStationConfig = stationConfig => dispatch => dispatch(
  createActionObject(
    actionTypes.SET_STATION_CONFIG,
    { stationConfig }
  )
)

export const setLongitude = longitude => dispatch => dispatch(
  createActionObject(
    actionTypes.SET_LONGITUDE,
    { 
      longitude
    }
  )
)

export const setLatitude = latitude => dispatch => dispatch(
  createActionObject(
    actionTypes.SET_LATITUDE,
    { 
      latitude
    }
  )
)

export const setLocation = location => dispatch => dispatch(
  createActionObject(
    actionTypes.SET_LOCATION,
    { 
      location
    }
  )
)

export const setCity = city => dispatch => dispatch(
  createActionObject(
    actionTypes.SET_CITY,
    { 
      city
    }
  )
)

export const setCountry = country => dispatch => dispatch(
  createActionObject(
    actionTypes.SET_COUNTRY,
    { 
      country
    }
  )
)

export const toggleDisabledConfirmation = getNoArgDispatcherFunc(actionTypes.TOGGLE_DISABLED_CONFIRMATION);

export const toggleStationConfigListDialog = getNoArgDispatcherFunc(actionTypes.TOGGLE_STATION_CONFIG_LIST_DIALOG)

export const toggleAlertDialog = getNoArgDispatcherFunc(actionTypes.TOGGLE_ALERT_DIALOG);

export const addGraphReference = graphReference => dispatch => dispatch(
  createActionObject(
    actionTypes.ADD_GRAPH_REFERENCE,
    { graphReference }
  )
);

export const removeGraphReference = index => dispatch => dispatch(
  createActionObject(
    actionTypes.REMOVE_GRAPH_REFERENCE,
    { index }
  )
)

export const selectFieldName = fieldName => dispatch => dispatch(
  createActionObject(
    actionTypes.SELECT_FIELD_NAME,
    { fieldName }
  )
)

export const selectAgg = agg => dispatch => dispatch(
  createActionObject(
    actionTypes.SELECT_AGG,
    { agg }
  )
);

export const closeSnackBar = getNoArgDispatcherFunc(actionTypes.CLOSE_SNACK_BAR);

export const resetActionStatus = getNoArgDispatcherFunc(actionTypes.RESET_ACTION_STATUS);